"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaretDown = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CaretDown = function CaretDown() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M6.207 10.483a.7.7 0 010-.993l.28-.28A.686.686 0 016.99 9h10.018a.686.686 0 01.504.21l.28.28a.7.7 0 010 .993l-5.303 5.304a.672.672 0 01-.98 0l-5.303-5.304z"
  });
};

exports.CaretDown = CaretDown;